import Joi from 'joi'
import AbstractModel from './AbstractModel'

export default class ClientModel extends AbstractModel {
  constructor (data) {
    super(data)
    Object.freeze(this)
  }

  static get schema () {
    return {
      clientId: Joi.string().required(),
      redirectUrls: Joi.array().items(
        Joi.string().required()
      ).allow(null),
      options: Joi.object().keys({
        colorTheme: Joi.string().allow(null, ''),
        signInOnSignUp: Joi.boolean(),
        autoGrant: Joi.boolean()
      })
    }
  }

  static fromJs (data) {
    return new ClientModel(data, { stripUnknown: true })
  }
}
